type CategoryLabels = Record<string, { name: string; parentId: string | null } | undefined>;

export function getCategoryParentName(categories: CategoryLabels, selected: string[]): string | undefined {
  const lastSelected = selected.at(-1);
  const parentId = lastSelected ? categories[lastSelected]?.parentId : undefined;
  return parentId ? categories[parentId]?.name : undefined;
}

export function getSelectedCategoryPath(categories: CategoryLabels, selected: string[]): string {
  return selected
    .map((id) => categories[id]?.name)
    .filter((name) => name !== undefined)
    .join('/');
}
